module.exports = {
	"base": {
		"welcome": "مرحبًا بك في Mulligans، %{name} !",
		"user": "معلومات المستخدم",
		"devices": "الأجهزة",
		"refunds": "استرداد الأموال",
		"resources": "الموارد",
		"transactions": "الطلبات والمرتجعات",
		"email": "البريد الإلكتروني",
		"password": "كلمة المرور",
		"save": "حفظ",
		"sign-out": "تسجيل الخروج",
		"cancel": "إلغاء",
		"close": "إغلاق",
		"learn-more": "أعرف المزيد",
		"required": "مطلوب",
		"support": "دعم",
		"bookshelf": "Bookshelf",
		"launch": "إطلاق",
		"download": "تنزيل",
		"details": "التفاصيل",
		"cannot-be-blank": "%{field} لا يمكن أن تكون فارغة.",
		"saving": "جارِ الحفظ...",
		"done": "تم",
		"failed": "فشل",
		"copy": "نسخ"
	},
	"signin": {
		"login-failure": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
		"welcome-large": "مرحبًا بك في <span class='inner'>مركز حساب %{brand}</span>",
		"welcome-small": "<span class='inner'> مركز الحساب </span>",
		"signin-button": "تسجيل الدخول",
		"forgot-password": "نسيت كلمة المرور الخاصة بك",
		"new-to-vst": "جديد لـ %{brand} ؟",
		"create-account": "إنشاء حساب",
		"signing-in": "تسجيل الدخول...",
		"signin-failed": "فشل تسجيل الدخول"
	},
	"transactions": {
		"price": "السعر",
		"excluded": "(باستثناء الضرائب)",
		"quantity": "الكمية",
		"confirmation#": "تأكيد #",
		"payment": "الدفع",
		"purchased": "ما تم شراؤه",
		"purchase-details": "تفاصيل الشراء",
		"subtotal": "المجموع الفرعي",
		"total": "إجمالي",
		"tax": "ضريبة",
		"loading": "أيها المنفق الكبير، نقوم بتحميل المعاملات الخاصة بك ...",
		"no-purchases": "لا يوجد لديك مشتريات.",
		"seller-vat": "ضريبة القيمة المضافة للبائع",
		"total-vat": "إجمالي %{vat} المدفوعة",
		"portion": "%{subTax} الضرائب بنسبة %{rate}%",
		"vat-disclosure": "يتضمن السعر %{vat}",
		"purchases": "المشتريات",
		"refunded-items": "العناصر التي تم الخصم عليها",
		"book-title": "عنوان الكتاب",
		"refund-details": "تفاصيل استرداد الأموال",
		"print-receipt": "طباعة الإيصال",
		"request-refund": "طلب استرداد الأموال",
		"expired": "انتهت مدة الصلاحية",
		"expires-in": "تنتهي في %{date}",
		"details-refund": "التفاصيل واسترداد الأموال",
		"modal": {
			"cant-refund-title": "استرداد الأموال غير متوفر",
			"cant-refund": "لا يمكن استرداد أموال كتابك لسبب أو أكثر من الأسباب التالية.",
			"cant-refund-1": "تم عرض نسخ كثيرة من كتابك.",
			"cant-refund-2": "لقد مضى أكثر من 14 يومًا من تاريخ الشراء.",
			"cant-refund-3": "تم الكشف عن رمز مواردك على الانترنت.",
			"cant-refund-4": "تم استرداد أموال كتابك مسبقًا.",
			"cant-refund-5": "تم بالفعل استعادة جميع الرموز و / أو استردادها.",
			"cant-refund-6": "لقد مضى أكثر من 30 يومًا من تاريخ الشراء.",
			"cant-refund-support": "إذا كنت لا تزال غير متأكد من سياسة استرداد %{brand} اتصل <a href='%{support_url}' target='_blank'>بالدعم </a>."
		},
		"license": {
			"perpetual": "الوصول عبر الإنترنت لا ينتهي",
			"days": "%{days} يوم الوصول"
		}
	},
	"devices": {
		"description": "يمكّنك %{brand} من أن يكون لديك <span>%{desktop}</span> أجهزة كمبيوتر و <span>%{mobile}</span> أجهزة محمول/كمبيوتر لوحي مفعلة في الوقت المحدد.",
		"loading": "هيا، نحن نحصل على الأجهزة الخاصة بك :)",
		"no-active": "لا يوجد لديك أجهزة نشطة.",
		"deactivate": "إلغاء التفعيل"
	},
	"user": {
		"personal-information": "المعلومات الشخصية",
		"security-information": "معلومات الأمان",
		"notifications": "الإشعارات",
		"first-name": "الاسم الأول",
		"last-name": "الاسم الأخير",
		"change-password-title": "تغيير كلمة المرور",
		"current-password": "كلمة المرور الحالية",
		"new-password": "كلمة المرور الجديدة",
		"security-password": "كلمة المرور",
		"confirm-new-password": "تأكيد كلمة المرور الجديدة",
		"security-question": "سؤال الأمان",
		"security-info-change": "تغيير",
		"question": "سؤال",
		"answer": "الإجابة",
		"notifications-text": "قم بإرسال التحديثات العرضية حول نشاط حسابي وتحديثات المنتج والعروض الخاصة.",
		"loading": "النقطة هي من جلبت معلومات المستخدم الخاصة بك، ثانية واحدة 🐶",
		"change-password-text": "يجب أن تحتوي كلمة المرور الجديدة على 8 حروف على الأقل وحرف كبير وحرف صغير وحرف خاص.",
		"email-locked": "تم إغلاق البريد الإلكتروني",
		"email-locked-description": "ليس لديك إمكانية الوصول لتغيير البريد الإلكتروني الخاص بك.",
		"email-locked-more": "يرجى الاتصال بالمسؤول.",
		"security-question6": "ما هي رياضتك المفضلة؟",
		"security-question7": "ما هي النكهة المفضلة لديك من الآيس كريم؟",
		"security-question8": "ما هو اسم الحيوان الأليف المفضل لديك؟",
		"security-question9": "عندما كنت صغيرًا، ماذا أردت أن تكون حينما تكبر؟",
		"security-question10": "ماذا كان الاسم الأخير للمدرس المفضل لديك؟",
		"new-password-failure": "لا تلبي كلمة المرور المتطلبات",
		"confirm-password-failure": "يجب أن تتطابق كلمة المرور",
		"new-password-tooltip": "يجب ان يحتوي على 8 حروف على الأقل، حرف كبير وحرف صغير وحرف خاص.",
		"enter-valid-email": "يرجى إدخال البريد الإلكتروني الصحيح.",
		"password-cannot-be-same": "لا يمكن أن تكون كلمة المرور هي نفس كلمة المرور السابقة",
		"incorrect-password": "كلمة مرور غير صحيحة",
		"complete-account": "يبدو أنك تحتاج إلى <a href='%{href}'>إكمال حسابك</a>.",
		"completing-allows": "يتيح لك إكمال حسابك إمكانية قراءة الكتب دون الاتصال بالإنترنت على تطبيقات الهاتف المحمول لديك ومشاركة الملاحظات والتمييزات مع الأصدقاء.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "المساعدون",
		"access-codes": "رموز الوصول",
		"print-on-demand": "طباعة عند الطلب",
		"check-pod": "قم بمراجعة خيارات طباعة الناشر في كتبك.",
		"check-now": "تحقق الآن",
		"loading": "انتظر برهة، نقوم بتحديث الموارد الخاصة بك!",
		"in": "في",
		"access-code-intro": "رمز الوصول هو كلمة المرور التي تستخدمها للوصول إلى محتوى الدورة على الانترنت. بمجرد أن يظهر رمز العنصر، فإنك لن تتمكن من إعادته. لمزيد من التعليمات حول كيفية استخدام رموز الوصول الخاصة بك، تفضل بزيارة <a href='%{support_url}' target='_blank'>الدعم</a>.",
		"expires": "تنتهي في",
		"expiration-message": "يحتوي على التعليمات الخاصة باستخدام رمز الوصول.",
		"copy-fail": "غير قادر على النسخ. يرجى اختيار رمز ونسخه يدويًا.",
		"launch-site": "إطلاق موقع",
		"launch-book": "طرح كتاب",
		"reveal-code": "إظهار الرمز",
		"no-resources": "ليس لديك أي موارد.",
		"no-access-codes": "ليس لديك أي رموز وصول.",
		"no-ancillaries": "لا يوجد مساعدون لهذا العنوان",
		"name": "الاسم",
		"type": "النوع",
		"size": "الحجم",
		"download-all": "تنزيل الكل",
		"back": "العودة إلى الموارد"
	},
	"refunds": {
		"states": {
			"refunded": "تم استردادها",
			"unavailable": "استرداد الأموال غير متوفر"
		},
		"reasons": {
			"dropped": "لقد تركت الدورة",
			"wrong": "كان هذا الكتاب الخاطيء لدورتي",
			"print": "قررت شراء نسخة مطبوعة بدلاً من ذلك",
			"missing": "لا يحتوي الكتاب على كل ما أحتاج إليه لدورتي (على سبيل المثال. قرص مضغوط، الوصول إلى شبكة الإنترنت، فيديوهات)",
			"other": "أخرى"
		},
		"bulk": {
			"policy": "بالضغط على زر &quot;استرداد كامل&quot; أدناه، فأنا أوافق على سياسة <a href='%{policy_url}' target='_blank'>استرداد %{brand}</a>.",
			"complete": "استرداد كامل",
			"view-details": "عرض تفاصيل الاسترداد",
			"success": "تم طلب استرداد أموالك. يرجى الانتظار 48 ساعة للمعالجة.",
			"failure": "عفوًا - شيٌء ما حدث بشكل خاطئ! للأسف لم يتم الاسترداد الخاص بك.",
			"retry": "حاول مرة أخرى",
			"support": "الاتصال بالدعم",
			"available-codes": "الرموز المتاحة",
			"codes-selected": "الرموز المحددة",
			"download": "رموز التنزيل",
			"partially-refunded": "استرداد جزئي",
			"pick-one": "يجب تحديد رمز واحد على الأقل لعمل استرداد"
		},
		"refund": "استرداد",
		"all": "استرداد الكل؟",
		"missing-reason": "يجب تحديد سبب للمتابعة",
		"missing-elaboration": "يرجى التوضيح",
		"policy": "بالضغط على زر \"استكمال طلب استرداد المال\" أدناه، أفهم أنه إذا قمت بشراء هذا الكتاب الإلكتروني من %{brand} مرة أخرى، لن أكون مؤهلاً لطلب أي مبالغ معادة أخرى لنفس الكتاب الإلكتروني. عرض سياسة الاسترداد بالكامل.",
		"refunded": "تم استردادها",
		"sorry": "نعتذر لأنك لم تكن راضيًَا عن عملية الشراء.",
		"error": "حدث خطأ ما",
		"error-explain": "لم نتمكن من معالجة استرداد الأموال. يرجى إعادة المحاولة.",
		"why": "أخبرنا عن السبب؟",
		"no-refunds": "لا يوجد لديك عناصر مستردة.",
		"select-codes": "حدد الرمز (الرموز) للاسترداد:",
		"number": "كم العدد؟",
		"back": "العودة إلى عمليات استرداد الأموال"
	},
	"purchases": {
		"back": "العودة إلى المشتريات"
	},
	"global-bar": {
		"account": "إعدادات الحساب"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ar.json
 ** module id = 993
 ** module chunks = 0
 **/